import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  type: string().oneOf(['cards', 'cards_tasks', 'cards_attachments', 'databases']).required(),
  status: string().oneOf(['pending', 'completed', 'failed']).required(),
});

/**
 * ExportCreateEvent
 *
 * - Evento emitido quando uma exportação é criada.
 */
export class ExportCreateEvent extends CreateCommand(RealtimeEventType.ExportCreate, SCHEMA) {}
